import React from 'react';

const BillingToggle = ({ isAnnual, setIsAnnual }) => (
  <div className="flex flex-col items-center justify-center mt-2 mb-4">
    <div className="inline-flex rounded-full bg-gray-100 dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700/50 p-1 shadow-sm">
      <button
        onClick={() => setIsAnnual(false)}
        className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${
          !isAnnual
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
        }`}
      >
        Monthly
      </button>
      <button
        onClick={() => setIsAnnual(true)}
        className={`px-6 py-2.5 rounded-full text-sm font-bold transition-all duration-300 ${
          isAnnual
            ? 'bg-gradient-to-r from-blue-500 via-cyan-500 to-purple-500 text-white shadow-glow-cyan'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
        }`}
      >
        🔥 Yearly: from 69% OFF
      </button>
    </div>

  </div>
);

export default BillingToggle;
